export const SupplierStockValidation = (formData) => {
    const errors = {};

    if (!formData.mon_CostPrice || !formData.mon_CostPrice.trim()) {
        errors.mon_CostPrice = 'This field is required';
    }

    

    if (!formData.dec_Quantity || !formData.dec_Quantity.trim()) {
        errors.dec_Quantity = 'This field is required';
    }

   
    

    return errors;
};

